import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full px-4 py-20 md:py-24 bg-bg-primary" data-id="element-152">
      <div className="max-w-4xl mx-auto" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-bg-card border border-border-card rounded-card p-8 md:p-12 text-center" data-id="element-154">
          <Shield className="w-16 h-16 text-orange mx-auto mb-6" data-id="element-155" />
          <h2 className="text-3xl md:text-4xl font-black mb-6" data-id="element-156">
            Garantía 7 días sin preguntas
          </h2>
          <p className="text-lg md:text-xl text-text-secondary mb-6 leading-relaxed" data-id="element-157">
            Abrí los 12 Tomos. Revisá los 6 Bonus. Usá los Ebooks Élite en tu
            sesión.
            <br data-id="element-158" />
            <br data-id="element-159" />
            Si no es lo que esperabas → 100% de devolución.
            <br data-id="element-160" />
            <br data-id="element-161" />
            Sin preguntas. Sin formularios. Sin drama.
          </p>
          <p className="text-sm text-emerald-400 font-bold" data-id="element-162">
            Tasa de devoluciones menor al 2%
          </p>
        </motion.div>
      </div>
    </section>;
}